import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  collection,
  doc,
  getFirestore,
  orderBy,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_firebase_apiKey,
  authDomain: process.env.NEXT_PUBLIC_firebase_authDomain,
  projectId: process.env.NEXT_PUBLIC_firebase_projectId,
  storageBucket: process.env.NEXT_PUBLIC_firebase_storageBucket,
  messagingSenderId: process.env.NEXT_PUBLIC_firebase_messagingSenderId,
  appId: process.env.NEXT_PUBLIC_firebase_appId,
};

initializeApp(firebaseConfig);

export const auth = getAuth();
export const db = getFirestore();
export const storage = getStorage();

export const getProfileRef = (uid) => (uid ? doc(db, "profiles", uid) : null);
export const getBriefRef = (uid) => (uid ? doc(db, "briefs", uid) : null);
export const getCampaignRef = (uid) => (uid ? doc(db, "campaigns", uid) : null);
export const getPresetRef = (id) => doc(db, "presetAds", id);
export const getPostRef = (id) => doc(db, "socialposts", id);

export const getPresetQuery = () =>
  query(collection(db, "presetAds"), orderBy("id", "desc"));

export const getPostQuery = () =>
  query(collection(db, "socialposts"), orderBy("id", "desc"));

export const getProfilesQuery = () =>
  query(collection(db, "profiles"), orderBy("businessName"));

function shuffle(array) {
  let currentIndex = array.length, randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

export async function getSamplePromptAds(industry, adType, language, exampleNum = 3) {
  let q = query(collection(db, "examplePromptAds"), where("industry", "==", industry), where("adType", "==", adType), where("language", "==", language));
  let querySnapshot = await getDocs(q);
  let doc_array = Array();
  querySnapshot.forEach((doc) => {
    doc_array.push(doc.data())
  });
  if (doc_array.length < exampleNum) {
    console.log(`Not enough examples within industry ${industry}, getting a general sample`);
    q = query(collection(db, "examplePromptAds"), where("adType", "==", adType), where("language", "==", language));
    querySnapshot = await getDocs(q);
    doc_array = Array();
    querySnapshot.forEach((doc) => {
      doc_array.push(doc.data());
    });
  } 
  return shuffle(doc_array).slice(0, exampleNum)
}

export const getBriefsQuery = () =>
  query(collection(db, "briefs"), orderBy("completedAt"));
